import React, { createRef, FC, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import type { FormInstance } from 'antd/es/form/Form'
import { Skeleton } from 'antd'
import {
    Button, Collapse, Form, Input, Space, List, Typography, Spin, notification, Table,
    Popover, Row, Col, Card, ConfigProvider
} from 'antd'
import { DeleteOutlined, CheckCircleOutlined, DownloadOutlined } from '@ant-design/icons'
import zhCN from 'antd/es/locale/zh_CN'
import moment from 'moment'
import PageBreadcrumb from '@/components/pageBreadcrumb'
import { IAppState } from '@/store/reducers'
import { getWorkgroup } from '@/store/actions/tableEdit.action'
import type { Descendant } from 'slate'
import type { DSlateRef } from '@dslate/core'
import { downloadFile, getUuid, hideLoading, showLoading } from '@/utils/util'
import { handleTrim, serialize } from '@/pages/table2Mana/table2Edit'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import {
    getFile, getOnlineReviewById, getOnlineReviewTMT, relevantGetById, selectReviewPenson,updateOpenViewStatus
} from '@/services/progress.service'
import { IAddOnlineReviewData, IFileRes } from '@/store/models/process.model'
import type { IBu } from '@/store/models/auth.model'
import SelectRelavant from '@/components/selectRelevant'
import Nav from '@/components/nav'

const SelectRelativeReviewSelectPerson: FC = () => {
    const history = useHistory()
    const locationObj = useLocation()
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()
    const locationSearch = useRef<any>({})
    const formRef = createRef<FormInstance>()
    const formRef2 = createRef<FormInstance>()
    // 富文本编辑器
    const editorRef = useRef<DSlateRef>(null)
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)
    const userInfo = useSelector((state: IAppState) => state.auth.userInfo)
    const { Panel } = Collapse
    const { Text } = Typography

    const [collapseValue, setCollapseValue] = useState<string[] | string>(['1', '2'])
    const [showSelectUser, setShowSelectUser] = useState(false)
    // const [showSelectUser2, setShowSelectUser2] = useState(false)
    const [judgesType, setJudgesType] = useState(1)
    // 富文本编辑器key
    // 提案申请相关性反馈
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [editorKey, setEditorKey] = useState<string>('1')
    // 独裁
    const [switchKey, setSwitchKey] = useState(['3', '4', '5', '6'])
    // 流程状态 0 申请  1 相关性  2 选择 TMT  3 TMT 反馈
    // const [processState, setProcessState] = useState(0)
    // 是否勾选相关性
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [isSelectRelevant, setIsSelectRelevant] = useState<number | undefined>()
    const [userLs, setUserLs] = useState<any[]>([])
    const [userLastLs, setUserLastLs] = useState<any[]>([])
    const [userLs2, setUserLs2] = useState<any[]>([])
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [userBackLs, setUserBackLs] = useState<IBu[]>([]) // 备份读取出来的人员列表
    const [loaded, setLoaded] = useState(false)
    // 查看信息
    const [formObj, setFormObj] = useState<(IAddOnlineReviewData) & {id: number, creator: string, files: IFileRes[]} | null>(null)
    // 回显反馈
    const [formObjFeed, setFormObjFeed] = useState<any>(null)
    // 已反馈用户列表
    const [feedbackList, setFeedbackList] = useState<any[]>([])
    // 是否已反馈过
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [feeded, setFeeded] = useState(false)
    // 记录是否参与
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [isParticipate, setIsParticipate] = useState<boolean | null>(null)
    const [loading, setLoading] = useState(false)
    // const [curWorkgroup, setCurWorkgroup] = useState<{
    //     id: number
    //     groupName: string
    // } | undefined>(undefined)
    // 富文本编辑器 内容
    // 提案申请相关性反馈
    const [descriptionValue, setDescriptionValue] = useState<Descendant[]>([
        {
            type: 'paragraph',
            children: [{ text: '' }],
        },
    ])

    const layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 15 },
    }
    const tailLayout = {
        wrapperCol: { offset: 10, span: 15 },
    }
    const approvalType = [
        { id: 1, label: t('technicalPlan') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
        { id: 2, label: t('technicalDefineAndResearchTaskBook') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
        { id: 3, label: t('technicalAchievementDelivery') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
        { id: 4, label: t('buTMTApproveTech') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
    ]
    const [columns, setColumns] = useState([
        {
            title: () => <span>{t('feedbackName')}</span>,
            dataIndex: 'creatorName',
            key: 'creatorName',
            width: 150,
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('WorkGroup')}</span>,
            dataIndex: 'workGroup',
            key: 'workGroup',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: any) {
                return value?.workGroupName || ''
            }
        },
        {
            title: () => <span>{t('isRelevant')}</span>,
            dataIndex: 'isRelevant',
            key: 'isRelevant',
            width: 100,
            ellipsis: { showTitle: true },
            // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
            render (value: boolean, record: any) {
                if (record.auditOrNot) {
                    return <span>{t('sitInOn')}</span>
                } else {
                    if (value !== null) {
                        if (value) {
                            return <span>{t('Yes')}</span>
                        }
                        return <span>{t('No')}</span>
                    } else {
                        return <></>
                    }
                }
            }
        },
        {
            title: () => <span>{t('tmtUser')}</span>,
            dataIndex: 'tmtInfos',
            key: 'tmtInfos',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: any[]) {
                return value.map(item => item.tmtFullUser).join(', ')
            }
        },
        {
            title: () => <span>{t('description')}</span>,
            dataIndex: 'description',
            key: 'description',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: string) {
                return <Popover 
                    placement="topLeft"
                    title=""
                    content={
                        <div style={{ maxWidth: 240, maxHeight: 300, overflowY: 'auto', wordBreak: 'break-all' }}
                            dangerouslySetInnerHTML={{
                                __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                            }}
                        ></div>
                    }
                >
                    <div style={{ maxWidth: 240 }}
                        className='table_ellipsis'
                        dangerouslySetInnerHTML={{
                            __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                        }}
                    ></div>
                </Popover>
            }
        },
    ])
    const tmtColumns = [
        {
            title: () => <span>{t('feedbackName')}</span>,
            dataIndex: 'tmtFullUser',
            key: 'tmtFullUser',
            width: 150,
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('WorkGroup')}</span>,
            dataIndex: 'workGroup',
            key: 'workGroup',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: any) {
                return value?.workGroupName || ''
            }
        },
        {
            title: () => <span>{t('isParticipate')}</span>,
            dataIndex: 'isParticipate',
            key: 'isParticipate',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: boolean | null, record: any) {
                if(record.judgesType == 1){
                    if(value == null){
                        return <span>{t('tobeConfirmed')}</span>
                    }
                    if(value){
                        return <span>{t('join')}</span>
                    }else{
                        return <span>{t('notAdd')}</span>
                    }
                }else{
                    return <span>{t('sitInOn')}</span>
                }
            }
        },
        // {
        //     title: () => <span>{t('isPassed')}</span>,
        //     dataIndex: 'isPassed',
        //     key: 'isPassed',
        //     width: 150,
        //     ellipsis: { showTitle: true },
        //     render (value: boolean | null) {
        //         if (value !== null) {
        //             if (value) {
        //                 return <span>{t('Yes')}</span>
        //             } else {
        //                 return <span>{t('No')}</span>
        //             }
        //         } else {
        //             return <></>
        //         }
        //     }
        // },
        {
            title: () => <span>{t('tmtMail')}</span>,
            dataIndex: 'tmtMail',
            key: 'tmtMail',
            width: 150,
            ellipsis: { showTitle: true }
        },
        {
            title: () => <span>{t('reviewContent')}</span>,
            dataIndex: 'reviewContent',
            key: 'reviewContent',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: string) {
                return <Popover 
                    placement="topLeft"
                    title=""
                    content={
                        <div style={{ maxWidth: 240, maxHeight: 300, overflowY: 'auto', wordBreak: 'break-all' }}
                            dangerouslySetInnerHTML={{
                                __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                            }}
                        ></div>
                    }
                >
                    <div style={{ maxWidth: 240 }}
                        className='table_ellipsis'
                        dangerouslySetInnerHTML={{
                            __html: value ? ((value.includes('"str":') || value.includes('"obj":')) ? JSON.parse(value)?.str : value) : ''
                        }}
                    ></div>
                </Popover>
            }
        },
    ]

    // 提案申请相关性反馈
    const onFinish = async (values: any) => {
        const editorHtmlValue = editorRef.current?.serialize({ children: serialize(handleTrim(descriptionValue)) }) || ''
        const formData = {
            ...values,
            isRelevant: values.isRelevant === 1,
            description: JSON.stringify({
                str: editorHtmlValue || '',
                obj: handleTrim(descriptionValue)
            }),
        }
        console.log('onFinish: ', values, formData)
        try {
            // 如果是选择相关性状态，则保存人员信息
            const selectUserLs = [
                ...userLs,
                ...userLs2
            ]
            const onlineReviewUserInfo: {
                idList: number[]
                reviewId: number
            } = {
                idList: selectUserLs.map(item => item.id),
                reviewId: values.techOnlineReviewId
            }
            // 保存选择人员
            setLoading(true)
            await selectReviewPenson(onlineReviewUserInfo).catch(() => {
                setLoading(false)
            })
            await getFeedbackTMTLs('' + onlineReviewUserInfo.reviewId).finally(() => {
                setLoading(false)
            })
            const args = {
                message: t('save') + (i18n.language !== 'zh' ? ' ' : '') + t('success'),
                description: '',
                icon: <CheckCircleOutlined style={{ color: '#08993f' }} />,
                duration: 3,
            }
            notification.open(args)
            // if (locationObj.key) {
            //     history.goBack()
            // } else {
            //     history.replace('/indexPage')
            // }
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    const onFinishFailed = ({ errorFields }: { errorFields: any}) => {
        console.log('onFinishFailed: ', errorFields)
    }
    const onChangeCollapse = (e: string[] | string) => {
        setCollapseValue(e)
    }
    const selectUserCallback = (selUsers: IBu[]) => {
        formRef.current?.setFieldValue('selectTmtUser', selUsers)
        formRef.current?.validateFields(['selectTmtUser'])
        const addLs: IBu[] = []
        const _userLs = judgesType === 1 ? [...userLs] : [...userLs2]
        selUsers.forEach(item => {
            const findIndex = _userLs.findIndex(user => user.id === item.id)
            if (findIndex !== -1) {
                addLs.push(_userLs[findIndex])
                _userLs.splice(findIndex, 1)
            } else {
                const findObjOld = userBackLs.find(user => user.id === item.id)
                // 找出原来已经加过的人，保留id
                if (findObjOld) {
                    addLs.push(findObjOld)
                } else {
                    addLs.push({ ...item })
                }
            }
        })
        // 选中人员再与原选择列表合并 并剔重
        const unionArr = _userLs.concat(addLs)
        if (judgesType === 1) {
            setUserLs(unionArr)
        } else {
            setUserLs2(unionArr)
        }
        formRef.current?.submit()
    }

    // 查看提案申请信息
    const getViewDetail = async (id: string) => {
        try {
            showLoading(<Spin size='large' />)
            const res = await getOnlineReviewById(+id).finally(() => {
                hideLoading()
            })
            setLoaded(true)
            setFormObj({
                ...res,
                id: res.id,
                version: res.version,
                fileIds: res.files.map(item => item.id),
                workGroupId: res.workGroup.id,
                roadMap: res.roadMap,
                proposalName: res.proposalName,
                subsidiary: res.subsidiary,
                reviewDate: moment(res.reviewDate),
                reviewDateHours: res.reviewDateHours,
                dueDate: moment(res.dueDate).format('YYYY-MM-DD'),
                isDisruptive: res.isDisruptive,
                reviewType:res.reviewType,
                openReview:res.openReview,
                isCross: res.isCross,
                techLevel: res.techLevel,
                description: res.description,
                creator: res.creator || '',
                costBuss: res.costBuss ? res.costBuss.map((item: any) => item.bu) : [],
                dutyBuss: res.dutyBuss ? res.dutyBuss.map((item: any) => item.bu) : [],
                files: res.files,
                reviewResult: res.reviewResult === null ? undefined : Boolean(res.reviewResult),
                tmtReviewDueDate: res.tmtReviewDueDate ? String(res.tmtReviewDueDate) : undefined
            })
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    const getFeedbackLs = async (id: string) => {
        try {
            const res = await relevantGetById(+id)
            setFeedbackList(res)
            // 找出自己填的记录，并回显
            if (userInfo) {
                // isParticipate === null 表示还未反馈
                const findObj = res.find(item => item.isParticipate !== null && item.creator === userInfo.login)
                if (findObj) {
                    // 如果找到自己的记录，则为已反馈
                    setFeeded(true)

                    // 是否相关
                    setIsSelectRelevant(findObj.isRelevant ? 1 : 2)
                    if (findObj.description) {
                        const descriptionObj = JSON.parse(findObj.description)
                        setDescriptionValue(descriptionObj.obj)
                        setEditorKey(getUuid(8))
                    }
                    formRef.current?.setFieldsValue({
                        techOnlineReviewId: id,
                        isRelevant: findObj.isRelevant ? 1 : 2,
                        description: findObj.description || '',
                        selectTmtUser: findObj.tmtInfos
                    })
                    setFormObjFeed({
                        techOnlineReviewId: id,
                        isRelevant: findObj.isRelevant ? 1 : 2,
                        description: findObj.description || '',
                        selectTmtUser: findObj.tmtInfos
                    })
                    setSwitchKey([getUuid(8), switchKey[1], switchKey[2], switchKey[3]])
                }
            }
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    const getFeedbackTMTLs = async (id: string) => {
        try {
            const res = await getOnlineReviewTMT(+id)
            setFeedbackList(res)
            // 找出自己填的记录，并回显
            console.log('tmt反馈列表: ', res)
            // isParticipate === null 表示还未反馈
            const userFilter = res.filter(item => item.isParticipate && item.judgesType === 1)
            setUserLs(userFilter)
            setUserLastLs(userFilter)
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    
    const subOpenVeiw = async (id: number | undefined) => {
        try {
            if (id !== undefined) {
                setLoading(true)
                await updateOpenViewStatus(id).catch(() => {
                    setLoading(false)
                })
                await getViewDetail('' + id).finally(() => {
                    setLoading(false)
                })
                const args = {
                    message: t('save') + (i18n.language !== 'zh' ? ' ' : '') + t('success'),
                    description: '',
                    icon: <CheckCircleOutlined style={{ color: '#08993f' }} />,
                    duration: 3,
                }
                notification.open(args)
            }
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }

    const [routes, setRoutes] = useState([
        {
            path: '/indexPage',
            breadcrumbName: t('indexPage'),
        },
        {
            path: '/techReviewProgress',
            breadcrumbName: t('technicalReviewProcess'),
        },
        {
            path: '/addProgress',
            breadcrumbName: t('selectTmtUser'),
        },
    ])
    useEffect(() => {
        console.log('locationObj: ', locationObj)
        const routeParams = new URLSearchParams(location.search)
        const progressIdParam = routeParams.get('progressId')
        const isWriteParam = routeParams.get('write')
        const type = routeParams.get('type')
        locationSearch.current = {
            progressId: +(progressIdParam || ''),
            isWrite: isWriteParam ? true : undefined
        }
        if (type) {
            localStorage.setItem('curTab', type)
        }
        routes[1] = {
            path: '/techReviewProgress',
            breadcrumbName: approvalType[(Number(type) || 1) - 1].label
        }
        if (progressIdParam) {
            getViewDetail(progressIdParam)
            if (!isWriteParam) {
                getFeedbackLs(progressIdParam)
            } else {
                getFeedbackTMTLs(progressIdParam)
                setColumns(tmtColumns)
                const curRoute = {
                    path: '/addProgress',
                    breadcrumbName: 'TMT' + (i18n.language !== 'zh' ? ' ' : '') + t('writeFeedback'),
                }
                routes.splice(routes.length - 1, 1, curRoute)
            }
            formRef.current?.setFieldValue('techOnlineReviewId', +progressIdParam)
        }
        setRoutes([...routes])
        if (!workgroupList.length) {
            // 获取 workgroupList
            dispatch(getWorkgroup())
        }
    }, [])
    // 详情
    useEffect(() => {
        if (formObj) {
            formRef2.current?.setFieldsValue(formObj)
        }
    }, [formObj])
    // 回显反馈
    useEffect(() => {
        if (formObjFeed && formRef.current) {
            formRef.current?.setFieldsValue(formObjFeed)
        }
    }, [formObjFeed])
    useEffect(() => {
        // 不设置值验证会报错
        formRef.current?.setFieldValue('description', 111)
    }, [descriptionValue])
    return (
        <Space direction="vertical" size={10} style={{ width: '100%' }}>
            <Nav dispatch={dispatch} />
            <PageBreadcrumb routerParam={routes}
                history={history}
                dispatch={dispatch}
            />
            <Collapse collapsible="header" className="edit_table"
                style={{ paddingTop: 0 }}
                activeKey={collapseValue}
                onChange={onChangeCollapse}
            >
                <Panel header={!locationSearch.current.isWrite ? t('selectTmtUser') : t('writeFeedback')} key="1"
                    forceRender
                    collapsible='disabled'
                >
                    <Row>
                        <Col span={13}>
                            <Form {...layout} ref={formRef}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                            >
                                <Form.Item name="techOnlineReviewId" hidden><Input /></Form.Item>
                                <>
                                    <Form.Item name='selectTmtUser'
                                        label={<span className='label'>{t('select') + (i18n.language !== 'zh' ? ' ' : '') + t('joinPersonList')}</span>}
                                        rules={[
                                            {
                                                required: true,
                                                validator: async () => {
                                                    if (userLs.length === 0) {
                                                        const helpStr = t('selectTmtUser Required')
                                                        return Promise.reject(new Error(helpStr))
                                                    } else {
                                                        return Promise.resolve()
                                                    }
                                                }
                                            }
                                        ]}
                                    >
                                        <Input hidden />
                                        {userLs.length > 0 && (<List style={{ marginBottom: 10, background: '#fff' }}
                                            bordered
                                            dataSource={userLs}
                                            renderItem={(item, index) => <List.Item
                                                key={item.id}
                                                actions={[
                                                    <Text className='txt_red hand' 
                                                        onClick={() => {
                                                            if(formObj?.openReview == null){
                                                                userLs.splice(index, 1)
                                                                setUserLs([...userLs])
                                                                formRef.current?.setFieldValue('reviewContent', userLs.length ? 111 : '')
                                                                formRef.current?.validateFields(['selectTmtUser'])
                                                                formRef.current?.submit()
                                                            }else{
                                                                const args = {
                                                                    message: t('approvalStarted'),
                                                                    description: '',
                                                                    icon: <CheckCircleOutlined style={{ color: '#efbe13a6' }} />,
                                                                    duration: 3,
                                                                }
                                                                notification.open(args)
                                                            }
                                                        }} title={t('delete')}><DeleteOutlined style={{ fontSize: 16 }} /></Text>
                                                ]}
                                            >{item.tmtFullUser}</List.Item>}
                                        />)}
                                        {formObj?.openReview == null && <Button
                                            onClick={() => {
                                                setJudgesType(1)
                                                setShowSelectUser(true)
                                            }}
                                        >{t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('tmtUser')}</Button>}
                                    </Form.Item>
                                </>
                                {/* 提交 */}
                                <Form.Item {...tailLayout}>
                                    <Space size={50}>
                                        {/* <Button type="primary" htmlType="submit"  disabled={formObj?.openReview != null} loading={loading}>{t('save') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewNameList')}</Button> */}
                                        <Button type="primary" onClick={()=> subOpenVeiw(formObj?.id)} disabled={userLastLs.length === 0 || formObj?.openReview != null} loading={loading}>{t('approval') + (i18n.language !== 'zh' ? ' ' : '') + t('start')}</Button>
                                    </Space>
                                </Form.Item>
                            </Form>
                        </Col>
                        <Col span={11}>
                            <Card title={t('viewInfo')} className='ti_an_detail'>
                                {loaded ?
                                    <Form {...layout} ref={formRef2}>
                                        <Form.Item name='workGroupId'
                                            label={<span className='label'>{t('Work Group')}</span>}
                                        >
                                            {workgroupList.find(workgroup => workgroup.id === formObj?.workGroupId)?.groupName}
                                        </Form.Item>
                                        <Form.Item name='proposalName'
                                            label={<span className='label'>{t('proposalName')}</span>}
                                        >
                                            {formObj?.proposalName}
                                        </Form.Item>
                                        <Form.Item name='reviewDate'
                                            label={<span className='label'>{t('reviewDate')}</span>}
                                        >
                                            {formObj?.reviewDate?.format('YYYY-MM-DD') + ' ' + (formObj?.reviewDateHours || '')}
                                        </Form.Item>
                                        {formObj?.reviewType !== 3 && (
                                            <>
                                                <Form.Item name='costBuss'
                                                    label={<span className='label'>{t('developCostAttribute')}</span>}
                                                >
                                                    {formObj?.costBuss?.join(', ')}
                                                </Form.Item>
                                                <Form.Item name='dutyBuss'
                                                    label={<span className='label'>{t('developDutySubject')}</span>}
                                                >
                                                    {formObj?.dutyBuss?.join(', ')}
                                                </Form.Item>
                                            </>
                                        )}
                                        {formObj?.reviewType === 1 && (
                                            <>
                                                <Form.Item name='isDisruptive'
                                                    label={<span className='label'>{t('isDisruptive')}</span>}
                                                >
                                                    {formObj?.isDisruptive ? t('Yes') : t('No')}
                                                </Form.Item>
                                                <Form.Item name='disruptiveReview'
                                                    label={<span className='label'>{t('isDisruptive') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewResult')}</span>}
                                                >
                                                    {formObj?.disruptiveReview !== null ? (formObj?.disruptiveReview ? t('Yes') : t('No')) : 'NA'}
                                                </Form.Item>
                                                <Form.Item name='isCross'
                                                    label={<span className='label'>{t('isCross')}</span>}
                                                >
                                                    {formObj?.isCross ? t('Yes') : t('No')}
                                                </Form.Item>
                                                <Form.Item name='isCrossReview'
                                                    label={<span className='label'>{t('isCross') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewResult')}</span>}
                                                >
                                                    {formObj?.isCrossReview !== null ? (formObj?.isCrossReview ? t('Yes') : t('No')) : 'NA'}
                                                </Form.Item>
                                            </>
                                        )}
                                        <Form.Item name='description'
                                            label={<span className='label'>{(formObj?.reviewType ? approvalType[formObj.reviewType - 1].label : '')
                                            + (i18n.language !== 'zh' ? ' ' : '') + t('description')}</span>}
                                        >
                                            <div dangerouslySetInnerHTML={{
                                                __html: formObj?.description ? JSON.parse(formObj?.description).str : ''
                                            }} style={{ wordBreak: 'break-word' }}></div>
                                        </Form.Item>
                                        <Form.Item name='files'
                                            label={<span className='label'>{t('attach')}</span>}
                                        >
                                            {formObj?.files
                                                ? <List
                                                    itemLayout="horizontal"
                                                    dataSource={formObj?.files}
                                                    renderItem={item => (
                                                        <List.Item className='attach_ls'
                                                            actions={[
                                                                // <Text className='txt_blue hand' title={t('previewFile')} onClick={async () => {
                                                                //     autoClick(`${UploadAPI}/onlinePreview?filePath=${item?.filePath}`)
                                                                // }}><FileSearchOutlined style={{ fontSize: 16 }} /></Text>
                                                            ]}
                                                        >
                                                            <Skeleton avatar title={false} loading={false} active>
                                                                <List.Item.Meta
                                                                    title={<span className='word txt_blue hand'
                                                                        title={item.fileName}
                                                                        onClick={async () => {
                                                                            showLoading(<Spin size='large' />)
                                                                            const res = await getFile(item.id).finally(() => {
                                                                                hideLoading()
                                                                            })
                                                                            downloadFile(res, item.fileName)
                                                                        }}
                                                                    >{item.fileName}<DownloadOutlined className='icon' /></span>}
                                                                />
                                                            </Skeleton>
                                                        </List.Item>
                                                    )}
                                                />
                                                : '无'
                                            }
                                        </Form.Item>
                                    </Form>
                                    : (
                                        <div 
                                            style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                                        ><Spin size="large" /></div>
                                    )
                                }
                            </Card>
                        </Col>
                    </Row>
                </Panel>
                {/* 已反馈列表 */}
                <Panel header={(!locationSearch.current.isWrite ? t('ITMT') : t('TMT') ) + (i18n.language !== 'zh' ? ' ' : '') + t('userList')} 
                    key="2"
                >
                    <ConfigProvider locale={i18n.language === 'zh' ? zhCN : undefined}>
                        <Table bordered
                            key={getUuid(8)}
                            dataSource={feedbackList}
                            columns={columns}
                            rowKey="id"
                            pagination={false}
                        ></Table>
                    </ConfigProvider>
                </Panel>
            </Collapse>
            {locationSearch.current.progressId && 
                (<SelectRelavant show={showSelectUser} setShow={setShowSelectUser}
                    title={t('selectTmtUser')}
                    isSecondProposal={!formObj?.parent ? false : true}
                    confirm={selectUserCallback}  
                    selectedKeysData={userLs.map(item => item.id.toString())}
                    judgesType={1}
                    id={locationSearch.current.progressId}
                />)
            }
            {/* {locationSearch.current.progressId &&
                (<SelectRelavant show={showSelectUser2} setShow={setShowSelectUser2}
                    title={t('selectTmtUser')}
                    confirm={selectUserCallback}
                    id={locationSearch.current.progressId}
                    judgesType={2}
                    selectedKeysData={userLs2.map(item => item.id.toString())}
                />)
            } */}
        </Space>
    )
}
export default SelectRelativeReviewSelectPerson
